import KendoDialog from '../KendoDialog'
import KendoDialogAction from '../KendoDialog/KendoDialogAction'

let KendoDialogInstaller = class {
    static install(Vue) {
        Vue.component(KendoDialog.name, KendoDialog)
        Vue.component(KendoDialogAction.name, KendoDialogAction)
    }
}

export default KendoDialogInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDialogInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/kendo-dialog-installer/index.js